<template>
  <div class="o-pagelayout" id="start">
    <div class="c-topbar">
      <div class="c-topbar__left">
        <a class="c-topbar__burger" href="#" @click.prevent="toggleSideMenu()" v-click-outside="hideMenu" data-toggle="collapse">
          <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <path
                d="M2.5 4.5h19a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-19A.5.5 0 0 1 2 7V5a.5.5 0 0 1 .5-.5zm0 6h19a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-19A.5.5 0 0 1 2 13v-2a.5.5 0 0 1 .5-.5zm0 6h19a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-19A.5.5 0 0 1 2 19v-2a.5.5 0 0 1 .5-.5z"
                id="a"
              />
            </defs>
            <use fill="currentColor" xlink:href="#a" transform="translate(-2 -4)" fill-rule="evenodd" />
          </svg>
          <span class="u-invisible">Menu</span>
        </a>
        <b-link to="/" class="c-logo">
          <p class="c-logo__signet">
            <mtg-logo />
            <strong class="u-invisible">MTG</strong>
          </p>
          <p class="c-logo__claim">
            <strong><br />{{ $t("lang.label_pqc_ca") }}</strong>
          </p>
        </b-link>
      </div>
      <div class="c-topbar__right">
        <div class="c-topbar__actions">
          <b-button-group class="c-topbar__action c-topbar__action--certificate">
            <b-button id="create-certificate-button" @click="createCertificate" variant="primary">
              <span>{{ $t("lang.label_certificate_createCert") }}</span>
              <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.65.484V9.35h8.866c.237 0 .435.171.476.397l.008.087v2.332a.484.484 0 0 1-.397.476l-.087.008H12.65v8.866a.484.484 0 0 1-.484.484H9.834a.484.484 0 0 1-.484-.484V12.65H.484a.484.484 0 0 1-.476-.397L0 12.166V9.834c0-.237.171-.435.397-.476l.087-.008H9.35V.484c0-.267.217-.484.484-.484h2.332c.267 0 .484.217.484.484z"
                  fill="currentColor"
                  fill-rule="evenodd"
                />
              </svg>
            </b-button>
          </b-button-group>
          <user-profile-dropdown />
        </div>
      </div>
    </div>
    <side-menu :show-menu.sync="showMenu"></side-menu>
    <main class="o-main" id="main">
      <div class="o-main__content">
        <alert-modal v-if="showAlert" :showAlert="showAlert"></alert-modal>
        <slot />
      </div>
    </main>
    <footer-component />
    <transition name="fade" mode="out-in">
      <loading-bar v-if="isLoading"></loading-bar>
    </transition>
    <b-modal id="modal-noIssuedCerts" centered :title="$t('lang.message_noAllowedCerts_label')" ok-only hide-header-close>
      <p class="my-4">
        {{ this.$t("lang.message_noAllowedCerts_1") }}
        {{ this.$t("lang.message_noAllowedCerts_2") }}
        <a :href="'mailto:pqc@mtg.de'" @click="$bvModal.hide('modal-noIssuedCerts')">pqc@mtg.de</a>
        {{ this.$t("lang.message_noAllowedCerts_3") }}
        <b-link :to="{ name: 'contact' }" @click="$bvModal.hide('modal-noIssuedCerts')">Contact</b-link>
        {{ this.$t("lang.message_noAllowedCerts_4") }}
      </p>
    </b-modal>
  </div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
import AlertModal from "../components/AlertModal";
import MtgLogo from "../components/layout/MtgLogo";
import UserProfileDropdown from "../components/UserProfileDropdown";
import FooterComponent from "../components/FooterComponent";
import LoadingBar from "@/components/LoadingBar";

export default {
  name: "MainLayout",
  components: {
    SideMenu,
    AlertModal,
    MtgLogo,
    UserProfileDropdown,
    FooterComponent,
    LoadingBar
  },
  data() {
    return {
      showUser: true,
      showMenu: false
    };
  },
  computed: {
    showAlert() {
      return this.$store.getters["alert/showAlert"];
    },
    isLoading() {
      return this.$store.getters["isLoading"];
    },
    statistics() {
      return this.$store.getters["certificate/certificateStatistics"];
    },
    isMobile() {
      return this.$isMobile();
    }
  },
  methods: {
    toggleSideMenu() {
      this.showMenu = !this.showMenu;
    },
    createCertificate() {
      const issuedCerts = this.statistics.data.certsIssued;
      if (issuedCerts.issued === issuedCerts.max) {
        this.$bvModal.show("modal-noIssuedCerts");
      } else {
        this.$router.push({ name: "certificate-create" });
      }
    },
    //emits this event for mobile device when ever user clicks outside the menu-bar div
    hideMenu(evt) {
      if (evt.target.closest("div") != null && evt.target.closest("div").classList.value === "c-sidebar__content") {
        return;
      }
      if (this.isMobile && this.showMenu) {
        this.showMenu = false;
      }
    }
  }
};
</script>
